









// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import EditDrawer from '@/components/shared/EditDrawer.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { getDefaultAloUser, AloUser } from '@/models/alo/AloUser';
import { toStringDictionary } from '@/utils/groupBy';

@Component({
  name: 'EditBaseUser',    
  components:{EditDrawer}, 
  props: {
    title:String,            
    width:{
      type:String,
      default:"1200"
    },
    saveLabel:{
      type:String,
      default:"Sauvegarder"
    },
    isMembre:{
      type:Boolean,
      default:false
    }
  } 
})
export default class EditBaseUser extends Vue {
  
  private original:AloUser = getDefaultAloUser()
  private modified:AloUser = getDefaultAloUser()
  private isMembre!:boolean
  private showDrawer = false  
  private saving = false  
    
  edit(item:AloUser) {
    this.$store.myActions.ADM_USER_RESET_STATUS()
    this.showDrawer = true
    this.original = {...getDefaultAloUser(),...item}    
    this.modified = cloneDeep(this.original)
  
    return this.modified
  }
  
  get configuration(){
    return this.$store.myGetters.configuration
  }

  get isDirty() {
    return !deepEqual(this.original,this.modified)
  }

  get userStatus() {
    return this.$store.myGetters.userStatus        
  }

  

  saveData() {    
    if ((this.$refs.editForm as HTMLFormElement).validate()) {
      this.saving = true
      if(this.isMembre){
        this.$store.myActions.ADM_USER_SAVE_MEMBER_REQUEST(this.modified).then((user) => {        
          this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.userStatus)          
          this.showDrawer = false
        }).finally(()=>{
          this.saving = false
        })   
      }
      else{
        this.$store.myActions.ADM_USER_SAVE_REQUEST(this.modified).then((user) => {        
          this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.userStatus)          
          this.showDrawer = false
        }).finally(()=>{
          this.saving = false
        })   
      } 
    } 
  }

}
